var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("img", {
    staticClass: "main-icon",
    attrs: { src: "/dist/assets/icon-analytics-coming-soon.svg" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }